import { ConfigProvider } from 'antd';

import ruRU from 'antd/lib/locale/ru_RU';
import React from 'react';
// import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import App from './App';
import enMessages from './locales/en.json';
import ruMessages from './locales/ru.json';
import reportWebVitals from './reportWebVitals';
import createStore from './store';
import './styles/index.css';

const store = createStore();

export type AppDispatch = typeof store.dispatch;

const preferredLanguage = window.navigator.language;

// ReactDOM.render(
//   <ConfigProvider locale={ruRU}>
//     <IntlProvider messages={preferredLanguage === 'en' ? enMessages : ruMessages} locale='en' defaultLocale='en'>
//       <Provider store={store}>
//         <App />
//       </Provider>
//     </IntlProvider>
//   </ConfigProvider>,
//   document.getElementById('root')
// );
import ReactDOM from 'react-dom/client';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ConfigProvider locale={ruRU}>
    <IntlProvider messages={preferredLanguage === 'en' ? enMessages : ruMessages} locale='en' defaultLocale='en'>
      <Provider store={store}>
        <App />
      </Provider>
    </IntlProvider>
  </ConfigProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
